/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.6.0 of "Payments service - Swift ISO Address Field configuration"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */
import type { Country } from '../models/Country';
import type { GetAddressConfigurationResponse } from '../models/GetAddressConfigurationResponse';
import type { OrderType } from '../models/OrderType';
import type { PaymentCategory } from '../models/PaymentCategory';

import { clientOptionsFactory } from '../clientOptions';
import { apiClientRequest as __request } from '@api-client/base';
import type { ClientOptions } from '@api-client/base';

export class SwiftIsoAddressConfigurationService {

    /**
     * Get Swift ISO address configuration for a specific country
     * @returns GetAddressConfigurationResponse Response w/ Swift ISO address configuration for specific country
     * @throws ApiError
     */
    public static getPublicConfigurationsAddresses({
        countryCode,
        acceptLanguage,
        paymentCategory,
        initiatingPartyAccountId,
        initiatingPartyAccountSearch,
        orderType,
        fallbackToDefault,
    }: {
        /**
         * 2 letter code as defined by ISO 3166
         */
        countryCode: Country,
        /**
         * The Accept-Language request HTTP header indicates the natural language and locale that the client prefers. Payment service will filter conditionalMessages based on this header and return only first message that matches accepted languages provided in the header.
         */
        acceptLanguage?: string,
        /**
         * Filter out specific payment category
         */
        paymentCategory?: PaymentCategory,
        /**
         * Initiating account id to recognize initiating account origin
         */
        initiatingPartyAccountId?: string,
        /**
         * Primary identifier of account (IBAN/BBAN) to recognize initiating account origin
         */
        initiatingPartyAccountSearch?: string,
        /**
         * Filter out specific order type
         */
        orderType?: OrderType,
        /**
         * Specifies whether default configuration should be returned if required configuration does not exist Default: true
         */
        fallbackToDefault?: boolean
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static getPublicConfigurationsAddresses({
        countryCode,
        acceptLanguage,
        paymentCategory,
        initiatingPartyAccountId,
        initiatingPartyAccountSearch,
        orderType,
        fallbackToDefault,
    }: {
        /**
         * 2 letter code as defined by ISO 3166
         */
        countryCode: Country,
        /**
         * The Accept-Language request HTTP header indicates the natural language and locale that the client prefers. Payment service will filter conditionalMessages based on this header and return only first message that matches accepted languages provided in the header.
         */
        acceptLanguage?: string,
        /**
         * Filter out specific payment category
         */
        paymentCategory?: PaymentCategory,
        /**
         * Initiating account id to recognize initiating account origin
         */
        initiatingPartyAccountId?: string,
        /**
         * Primary identifier of account (IBAN/BBAN) to recognize initiating account origin
         */
        initiatingPartyAccountSearch?: string,
        /**
         * Filter out specific order type
         */
        orderType?: OrderType,
        /**
         * Specifies whether default configuration should be returned if required configuration does not exist Default: true
         */
        fallbackToDefault?: boolean
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<GetAddressConfigurationResponse>;
    public static getPublicConfigurationsAddresses({
        countryCode,
        acceptLanguage,
        paymentCategory,
        initiatingPartyAccountId,
        initiatingPartyAccountSearch,
        orderType,
        fallbackToDefault
    }: {
        /**
         * 2 letter code as defined by ISO 3166
         */
        countryCode: Country,
        /**
         * The Accept-Language request HTTP header indicates the natural language and locale that the client prefers. Payment service will filter conditionalMessages based on this header and return only first message that matches accepted languages provided in the header.
         */
        acceptLanguage?: string,
        /**
         * Filter out specific payment category
         */
        paymentCategory?: PaymentCategory,
        /**
         * Initiating account id to recognize initiating account origin
         */
        initiatingPartyAccountId?: string,
        /**
         * Primary identifier of account (IBAN/BBAN) to recognize initiating account origin
         */
        initiatingPartyAccountSearch?: string,
        /**
         * Filter out specific order type
         */
        orderType?: OrderType,
        /**
         * Specifies whether default configuration should be returned if required configuration does not exist
         */
        fallbackToDefault?: boolean,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'GET',
            url: '/public/configurations/addresses/{countryCode}',
            path: {
                'countryCode': countryCode,
            },
            query: {
                'paymentCategory': paymentCategory,
                'initiatingPartyAccountId': initiatingPartyAccountId,
                'initiatingPartyAccountSearch': initiatingPartyAccountSearch,
                'orderType': orderType,
                'fallbackToDefault': fallbackToDefault,
            },
            headers: {
                'Accept-Language': acceptLanguage,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Get Swift ISO address configuration for standing orders in a specific country
     * Returns address configurations for standing order payments.
     * If countryCode matches the tenant's country, returns the DOMESTIC payment category configuration.
     * If countryCode differs from the tenant's country, returns the SEPA payment category configuration.
     *
     * @returns GetAddressConfigurationResponse Response w/ Swift ISO address configuration for specific country
     * @throws ApiError
     */
    public static getPublicConfigurationsAddressesStandingOrders({
        countryCode,
        acceptLanguage,
        initiatingPartyAccountId,
        initiatingPartyAccountSearch,
        fallbackToDefault,
    }: {
        /**
         * 2 letter code as defined by ISO 3166
         */
        countryCode: Country,
        /**
         * The Accept-Language request HTTP header indicates the natural language and locale that the client prefers. Payment service will filter conditionalMessages based on this header and return only first message that matches accepted languages provided in the header.
         */
        acceptLanguage?: string,
        /**
         * Initiating account id to recognize initiating account origin
         */
        initiatingPartyAccountId?: string,
        /**
         * Primary identifier of account (IBAN/BBAN) to recognize initiating account origin
         */
        initiatingPartyAccountSearch?: string,
        /**
         * Specifies whether default configuration should be returned if required configuration does not exist Default: true
         */
        fallbackToDefault?: boolean
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static getPublicConfigurationsAddressesStandingOrders({
        countryCode,
        acceptLanguage,
        initiatingPartyAccountId,
        initiatingPartyAccountSearch,
        fallbackToDefault,
    }: {
        /**
         * 2 letter code as defined by ISO 3166
         */
        countryCode: Country,
        /**
         * The Accept-Language request HTTP header indicates the natural language and locale that the client prefers. Payment service will filter conditionalMessages based on this header and return only first message that matches accepted languages provided in the header.
         */
        acceptLanguage?: string,
        /**
         * Initiating account id to recognize initiating account origin
         */
        initiatingPartyAccountId?: string,
        /**
         * Primary identifier of account (IBAN/BBAN) to recognize initiating account origin
         */
        initiatingPartyAccountSearch?: string,
        /**
         * Specifies whether default configuration should be returned if required configuration does not exist Default: true
         */
        fallbackToDefault?: boolean
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<GetAddressConfigurationResponse>;
    public static getPublicConfigurationsAddressesStandingOrders({
        countryCode,
        acceptLanguage,
        initiatingPartyAccountId,
        initiatingPartyAccountSearch,
        fallbackToDefault
    }: {
        /**
         * 2 letter code as defined by ISO 3166
         */
        countryCode: Country,
        /**
         * The Accept-Language request HTTP header indicates the natural language and locale that the client prefers. Payment service will filter conditionalMessages based on this header and return only first message that matches accepted languages provided in the header.
         */
        acceptLanguage?: string,
        /**
         * Initiating account id to recognize initiating account origin
         */
        initiatingPartyAccountId?: string,
        /**
         * Primary identifier of account (IBAN/BBAN) to recognize initiating account origin
         */
        initiatingPartyAccountSearch?: string,
        /**
         * Specifies whether default configuration should be returned if required configuration does not exist
         */
        fallbackToDefault?: boolean,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'GET',
            url: '/public/configurations/addresses/{countryCode}/standing-orders',
            path: {
                'countryCode': countryCode,
            },
            query: {
                'initiatingPartyAccountId': initiatingPartyAccountId,
                'initiatingPartyAccountSearch': initiatingPartyAccountSearch,
                'fallbackToDefault': fallbackToDefault,
            },
            headers: {
                'Accept-Language': acceptLanguage,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

}
